import React, { Component } from 'react';

class LiveExperience extends Component {


    constructor() {
        super();
        this.state = {

        }
    }
    componentDidMount() {
        this.patientExpTest();
        var patientAppDomain;
        if (window.location.hostname == "dev-admin.myjeeva.net") {
            patientAppDomain = "dev-patient.myjeeva.net";
        } else if (window.location.hostname == "stage-admin.myjeeva.net") {
            patientAppDomain = "stage-patient.myjeeva.net";
        } else if (window.location.hostname == "admin.myjeeva.net") {
            patientAppDomain = "patient-app.myjeeva.net";
        }
        this.state.patientAppDomain = patientAppDomain;
    }


    patientExpTest = () => {

        var previewIframe = decodeURI(document.getElementById('previewIframe').src);
        previewIframe = previewIframe;
        this.setState(this.state);
    }

    render() {
        return (
            <div id="tabPage" style={{ height: '120vh', overflow: 'hidden' }}>
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div className="content-header" >
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-5">
                                    <h1 className="m-0 page-title">Patient App Experience</h1>
                                </div>
                                <div className="col-sm-4">

                                </div>


                            </div>

                        </div>
                    </div>

                    <div className="container-fluid" >

                        <div style={{
                            width: '483px', height: '1022px', paddingTop: '73px', paddingLeft: '26px',
                            paddingRight: '26px', paddingBottom: '73px', marginLeft: '25%',
                            backgroundImage: 'url(/my-jeeva/assets/images/phoneOutline.png)'
                        }}>
                            <iframe style={{ border: "none", height: '100%', width: '100%' }}
                                src={"https://" + this.state.patientAppDomain+"/index.html"}
                                allow="geolocation;camera;microphone"
                                id="previewIframe"></iframe>
                        </div>
                    </div>
                </div>
            </div >

        );
    }
}
export default LiveExperience;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/LiveExperience.js